import React, { useEffect, useRef, useState } from "react";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import clearicon from "../../../../../assets/img/Vector.svg"
import useSignalR from "../../../../ChatBot/useSignalR";
import TasksNotifications from "./TasksNotifications";
import MessageNotifications from "./MessageNotifications";
import AlertNotofications from "./AlertNotofications";
import AllNotifications from "./AllNotifications";
import NotificationHandler from "../../../../../utils/NotificationHandler";
import { enumUtil } from "../../../../../utils/Enum";
import store from "../../../../../store";
import { NoNotificationIcon } from "../../../../shared/IconsComponent/icons";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { addSignalRConnection, isReconnected } from "../../../../../actions/SignalRhubs";
import AddNewTask from '../../../../Home/TaskManagement/AddNewTask'
import notification from '../../../../../assets/sound/msg.mp3'
import Addalert from "../../../../General/AddAlert";
import isNull from "../../../../../utils/NullChecking";
import AppLogo from "../../../../../assets/img/WinNotification.svg";
import { GeneralDropDowns } from "../../../../../actions/GeneralPatientActions";
const audio = new Audio(notification);
const Notifications = () => {
  const dispatch = useDispatch();
  const API_URL = process.env.REACT_APP_API

  const [connection, setConnection] = useState(null);
  let conn = useSignalR(API_URL + "NotificationsHub", 'NotificationsHub').connection;
  useEffect(() => {
    setConnection(conn);
  }, [conn]);


  // console.log(connection);

  let isReconnectedToHub = useSelector(state => state.SignalRhubsReducer?.ReconnectingNotificationsHub)
  let ConnectedtaskNotificationsHub = useSelector(state => state.SignalRhubsReducer?.NotificationsHub)
  let GenDD = useSelector(state => state.GeneralDropDownsReducer)
  const [TaskID, SetTaskID] = useState()
  const [notification, setnotification] = useState(false);
  const popupRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      const isInsidePopupScreen = event.target.closest('.new_task_modal');
      const isInsideAlert = event.target.closest('.hk-alert__modal');
      const isInsideDatePicker = event.target.closest('.MuiPopover-root');
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        !isInsidePopupScreen &&
        !isInsideAlert &&
        !isInsideDatePicker
      ) {
        setnotification(false);
      }
    }
    if (notification) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notification]);
  const [taskNotifications, setTasksNotifications] = useState([])
  const [isConnected, setisConnected] = useState(false)
  const [nofityMe, setNofityMe] = useState(false);




  //Alert 
  const [alertNotifications, setAlertNotifications] = useState([])

  const checkType = (operation, data) => {
    if (operation === "New" || operation === "Assignee") {
      return `${data.AssignedBy} assigned this task to you`;
    } else if (operation === "Update") {
      return `${data.AssignedBy} updated task details`;
    } else if (operation === "Comment") {
      return `${data.AssignedBy} added comment`;
    } else if (operation === "Reply") {
      return `${data.AssignedBy} replied to comment`;
    } else if (operation === "Overdue") {
      return "Task is overdue";
    } else if (operation === "Mention") {
      return `${data.AssignedBy} mentioned you in task comments`;
    }
  }
  useEffect(() => {
    if (connection) {
      setisConnected(true)
      connection.on("ReceiveTaskNotification", (notifications) => {
        setTasksNotifications(prevNotifi => [notifications, ...prevNotifi]);
        setNofityMe(true);
        audio.play().catch(error => {
          console.error("Error playing sound:", error);
        });


        showSystemNotification({
          title: checkType(notifications.Operation, notifications),
          body: notifications.TaskTitle || "You have a new task update.",
          onClick: () => {
            // Optional: open the task in your app
            SetTaskID(notifications.TaskID);
            setIsopen(true);
          }
        });
        //Alert ReceiveAlertNotification
        setTimeout(() => {
          setNofityMe(false);
        }, 1000);
      });
      connection.on("ReceiveAlertNotification", (notifications) => {
        setAlertNotifications(prevNotifi => [notifications, ...prevNotifi]);
        setNofityMe(true);
        audio.play().catch(error => {
          console.error("Error playing sound:", error);
        });
        setTimeout(() => {
          setNofityMe(false);
        }, 1000);
      });

      connection.on("UpdateTaskCountForUser", (notifications) => {
        dispatch(GeneralDropDowns({ ...GenDD, TaskCount: notifications }))
      });
      // connection.on("UpdateSupportTicketCountForUser", (notifications) => {
      //   dispatch(GeneralDropDowns({ ...GenDD, SupportTicketCount: notifications }))
      // });
      // return () => {
      //   connection.off("ReceiveTaskNotification");
      // };
    }
  }, [connection]);
  useEffect(() => {
    if (connection && isConnected) {
      console.log('ReceiveUndelieveredNotifications should only run first time');

      connection.on("ReceiveUndelieveredNotifications", (notifications) => {
        try {
          setTasksNotifications(notifications);
        } catch (error) {
          console.error("Error in ReceiveUndelieveredNotifications:", error);
        }
      });

      // Alert ReceiveUndelieveredAlertNotifications
      connection.on("ReceiveUndelieveredAlertNotifications", (notifications) => {
        try {
          setAlertNotifications(notifications);
        } catch (error) {
          console.error("Error in ReceiveUndelieveredAlertNotifications:", error);
        }
      });
    }
  }, [isConnected]);
  useEffect(() => {
    if (connection) {
      dispatch(addSignalRConnection("NotificationsHub", connection));
    }
  }, [dispatch]);
  useEffect(() => {
    if (isReconnectedToHub && connection?.state === "Disconnected" && ConnectedtaskNotificationsHub) {
      let ShouldReconnect = false
      setConnection(ConnectedtaskNotificationsHub)
      ConnectedtaskNotificationsHub.on("ReceiveUndelieveredNotifications", (notifications) => {
        try {
          setTasksNotifications(notifications);
          ShouldReconnect = true
          // dispatch(isReconnected('NotificationsHub', false));                               // will have to check tis because of 2time req
        } catch (error) {
          setTasksNotifications([]);
          console.error("Error in ReceiveUndelieveredNotifications:", error);
        }
        // setMessages(prevMessages => [...prevMessages, newMessage]);
      });
      ConnectedtaskNotificationsHub.on("ReceiveUndelieveredAlertNotifications", (notifications) => {
        try {
          setAlertNotifications(notifications);
          ShouldReconnect = true
          // dispatch(isReconnected('NotificationsHub', false));                     // will have to check tis because of 2time req
        } catch (error) {
          setAlertNotifications([]);
          console.error("Error in ReceiveUndelieveredAlertNotifications:", error);
        }
        // setMessages(prevMessages => [...prevMessages, newMessage]);
      });
      if (ShouldReconnect) {
        dispatch(isReconnected('NotificationsHub', false));
      }
    }
  }, [isReconnectedToHub, ConnectedtaskNotificationsHub])
  const returnPriorityFlag = (Priority) => {
    return (
      Priority === 'Urgent' ? <i className="icon-Vector-8 fs-12"></i> :
        Priority === 'High' ? <i className="icon-Vector-9 fs-12"></i> :
          Priority === 'Normal' ? <i className="icon-Vector-10 fs-12"></i> :
            Priority === 'Low' ? <i className="icon-flag-2-svgrepo-com-1 fs-12"></i> :
              Priority === 'Clear' ? <img src={clearicon} height='12px' className="empty"></img> :
                <img src={clearicon} className="empty"></img>
    )
  }
  const returnPriority = (Priority) => {
    let newCls = ''
    if (Priority === 'Urgent') {
      newCls = 'Denied-clr'
    } else if (Priority === 'High') {
      newCls = 'High'
    } else if (Priority === 'Normal') {
      newCls = 'NORMAL'
    } else if (Priority === 'Low') {
      newCls = 'LOW'
    }
    return <p className={`text font-m ${newCls}`}>{Priority}</p>
  }
  const returnStatus = (Status) => {
    let newCls = ''
    if (Status === 'Open') {
      newCls = 'In-Lobby'
    } else if (Status === 'In Review') {
      newCls = 'In-Review'
    } else if (Status === 'Closed') {
      newCls = 'Paid'
    } else if (Status === 'In Progress') {
      newCls = 'Blue-Status'
    }
    return <p className={`pill heading ${newCls}`}> {Status}</p>
  }
  const notificationType = (data, index) => {
    if (data.Operation === "New" || data.Operation === "Assignee") {
      return (
        <div className={data.IsNotificationSeen === 'true' ? "ar-content-box assigned light" : "ar-content-box assigned"}>
          <div className='d-flex align-items-center justify-content-between pb-1'>
            <p className='text font-m ar-dark-color hover-heading' onClick={() => openTask(data.TaskID, index, data.TaskNotificationsID)}>{data.AssignedBy} assigned this task to you</p>
            <p className='text fs-9 ar-dot ar-dark-color'>{data.CreatedDate}</p>
            <i className='icon-x-cros fs-16 dark-clr d-none' onClick={() => AcknowledgeTask(data.TaskNotificationsID, index)}></i>
          </div>
          <div className="d-flex align-items-center justify-content-between pb-1">
            <p className='text ar-light-color validation_message text-nowrap w-80'>{data.TaskTitle}</p>
            <div className="">
              <span className="prioity m-auto cursor-pointer" >
                <span className="icon-Vector-2">
                  {returnPriorityFlag(data.OldTaskPriority)}
                </span>
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center ">
            <div className="d-flex align-items-center gap-12">
              <p className="text fs-11 ar-light-color"><span className="font-m">Category: </span>{data.TaskFor}</p>
              <p className="text fs-11 ar-light-color"><span className="font-m">Due date: </span>{data.OldDueDate}</p>
            </div>
            <div className="">
              {returnStatus(data.OldTaskStatus)}
            </div>
          </div>
        </div>
      )
    } else if (data.Operation === "Update") {
      return (
        <div className={data.IsNotificationSeen === 'true' ? "ar-content-box light" : "ar-content-box"}>
          <div className='d-flex align-items-center justify-content-between pb-1'>
            <p className='text font-m ar-dark-color hover-heading' onClick={() => openTask(data.TaskID, index, data.TaskNotificationsID)}>{data.AssignedBy} updated task details</p>
            <p className='text fs-9 ar-dot ar-dark-color'>{data.CreatedDate}</p>
            <i className='icon-x-cros fs-16 dark-clr d-none' onClick={() => AcknowledgeTask(data.TaskNotificationsID, index)}></i>
          </div>
          <div className="">
            <p className='text ar-light-color pb-1 validation_message text-nowrap'>{data.TaskTitle}</p>
            {data.NewTaskStatus ?
              <div className="d-flex align-items-center gap-12 pb-2">
                {/* <p className='pill w-85px In-Lobby'>{data.OldTaskStatus}</p> */}
                {returnStatus(data.OldTaskStatus)}

                <i className='icon-arrow fs-7'> </i>
                {returnStatus(data.NewTaskStatus)}

                {/* <p className='pill In-Review'>{data.NewTaskStatus}</p> */}
              </div>
              : null}
            {data.NewTaskPriority ?
              <div className="d-flex align-items-center gap-12 pb-2">
                {returnPriority(data.OldTaskPriority)}
                <i className='icon-arrow fs-7'> </i>
                {returnPriority(data.NewTaskPriority)}
              </div>
              : null}
            {data.NewDueDate ?
              <div className="d-flex align-items-center gap-12">
                <p className='text fs-11 w-85px ar-light-color'>{data.OldDueDate}</p>
                <i className='icon-arrow fs-7'> </i>
                <p className='text Paid-clr'>{data.NewDueDate}</p>
              </div>
              : null}
          </div>
        </div>
      )
    } else if (data.Operation === "Comment") {
      return (
        <div className={data.IsNotificationSeen === 'true' ? "ar-content-box light" : "ar-content-box"}>
          <div className='d-flex align-items-center justify-content-between pb-1'>
            <p className='text font-m ar-dark-color hover-heading' onClick={() => openTask(data.TaskID, index, data.TaskNotificationsID, data.Operation)}>{data.AssignedBy} added comment</p>
            <p className='text fs-9 ar-dot ar-dark-color'>{data.CreatedDate}</p>
            <i className='icon-x-cros fs-16 dark-clr d-none' onClick={() => AcknowledgeTask(data.TaskNotificationsID, index)}></i>
          </div>
          <p className='text ar-light-color pb-1 validation_message text-nowrap'>{data.TaskTitle}</p>
          <p className='text ar-light-color fs-11'>Comment: {data.Comment}</p>
        </div>
      )
    } else if (data.Operation === "Reply") {
      return (
        <div className={data.IsNotificationSeen === 'true' ? "ar-content-box light" : "ar-content-box"}>
          <div className='d-flex align-items-center justify-content-between pb-1'>
            <p className='text font-m ar-dark-color hover-heading' onClick={() => openTask(data.TaskID, index, data.TaskNotificationsID, data.Operation)}>{data.AssignedBy} replied to comment </p>
            <p className='text fs-9 ar-dot ar-dark-color'>{data.CreatedDate}</p>
            <i className='icon-x-cros fs-16 dark-clr d-none' onClick={() => AcknowledgeTask(data.TaskNotificationsID, index)}></i>
          </div>
          <p className='text ar-light-color pb-1 validation_message text-nowrap'>{data.TaskTitle}</p>
          <p className='text ar-light-color fs-11'>Comment: {data.Comment}</p>
        </div>
      )
    } else if (data.Operation === "Overdue") {
      return (
        <div className={data.IsNotificationSeen === 'true' ? "ar-content-box light" : "ar-content-box"}>
          <div className='d-flex align-items-center justify-content-between pb-1'>
            <p className='text font-m ar-dark-color hover-heading' onClick={() => openTask(data.TaskID, index, data.TaskNotificationsID)}>Task is overdue</p>
            <p className='text fs-9 ar-dot ar-dark-color'> {data.CreatedDate}</p>
            <i className='icon-x-cros fs-16 dark-clr d-none' onClick={() => AcknowledgeTask(data.TaskNotificationsID, index)}></i>
          </div>
          <div className="">
            <div className="d-flex align-items-center justify-content-between pb-1">
              <p className='text ar-light-color'>{data.TaskTitle}</p>
              <div className="">
                <span className="prioity m-auto cursor-pointer" >
                  <span className="icon-Vector-2">
                    {returnPriorityFlag(data.OldTaskPriority)}
                  </span>
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center ">
              <div className="d-flex align-items-center gap-12">
                <p className="text fs-11 ar-light-color"><span className="font-m">Category: </span>{data.TaskFor}</p>
                <p className="text fs-11 ar-light-color"><span className="font-m">Due date: </span> <span className='Denied-clr'>{data.OldDueDate}</span></p>
              </div>
              <div className="">
                {returnStatus(data.OldTaskStatus)}
              </div>
            </div>
          </div>
        </div>
      )
    } else if (data.Operation === "Mention") {
      return (
        <div className={data.IsNotificationSeen === 'true' ? "ar-content-box light" : "ar-content-box"}>
          <div className='d-flex align-items-center justify-content-between pb-1'>
            <p className='text font-m ar-dark-color hover-heading' onClick={() => openTask(data.TaskID, index, data.TaskNotificationsID)}>{data.AssignedBy} mentioned you in task comments</p>
            <p className='text fs-9 ar-dot ar-dark-color'>{data.CreatedDate}</p>
            <i className='icon-x-cros fs-16 dark-clr d-none' onClick={() => AcknowledgeTask(data.TaskNotificationsID, index)}></i>
          </div>
          <p className='text ar-light-color pb-1 validation_message text-nowrap'>{data.TaskTitle}</p>
          <p className='text ar-light-color fs-11'>Comment: {data.Comment}</p>
        </div>
      )
    }
  }
  const [Isopen, setIsopen] = useState(false);
  const [OpenCommentbyDefault, setOpenCommentbyDefault] = useState(false);
  const openTask = (id, index, notificationID, Operation) => {
    SetTaskID(id)
    let data = [...taskNotifications]
    data[index].IsNotificationSeen = 'true'
    setTasksNotifications(data)
    if (connection) {
      connection.invoke("MarkTaskNotificationSeen", notificationID).catch((err) => console.error(err.toString()));
    }
    setOpenCommentbyDefault(Operation === "Comment" || Operation === "Reply" ? true : false)
    setIsopen(true)
  }
  const closeTask = () => {
    setIsopen(false)
  }
  let popupScreen = ""
  if (Isopen) {
    popupScreen = <AddNewTask IsOpen={openTask} IsClosed={closeTask} onDeleteTask={closeTask} Task={TaskID} OpenCommentbyDefault={OpenCommentbyDefault} />
  }
  const AcknowledgeTask = (id, index) => {
    let data = [...taskNotifications]
    data.splice(index, 1);
    setTasksNotifications(data)
    if (connection) {
      connection.invoke("AcknowledgeTaskNotification", id).catch((err) => console.error(err.toString()));
    }
  }
  const handleMarkAll = () => {
    let token = store.getState();
    token = token.Login.token
    if (connection) {
      connection.invoke("AcknowledgeAllTaskNotification").catch((err) => console.error(err.toString()));
      setTasksNotifications([])
    }
  }
  useEffect(() => {
    audio.load();
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    }
  }, []);


  // show alert type
  const [isAlertVisible, setAlertVisible] = useState(false);
  const [AlertID, setAlertID] = useState()
  const [AlertType, setAlertType] = useState()
  const OpenAlert = (data) => {
    setAlertVisible(true)
    setAlertID(data.AlertID)
    setAlertType(data.Type)
  }
  const CloseCategory = () => {
    setAlertVisible(false)
    setAlertID(null)
  }
  let Alert
  if (isAlertVisible && !isNull(AlertID)) {
    Alert = <Addalert isOpenAlertType={isAlertVisible} onClose={CloseCategory} Contains={AlertID} Name={AlertType} />
  }

  // show notification in windows style
  const showSystemNotification = ({ title, body, onClick }) => {
    if (Notification.permission === "granted") {
      const notification = new Notification(title, {
        body,
        icon: AppLogo, // Or any small app icon
        //       image: AppLogo,    // Optional preview (Chrome only)
        // badge:AppLogo 
      });

      notification.onclick = () => {
        window.focus();
        if (onClick && typeof onClick === "function") {
          onClick();
        }
      };
      console.log(notification);
    }
  };
  return (
    <>
      {popupScreen}
      {Alert}
      <div className="alert-icon app_tooltip session-btn bottom" onClick={() => setnotification(!notification)}>
        <i className={`bi bi-bell-fill mt-2 ${nofityMe ? 'bell-animation' : ''}`} ></i>
        <p class="tool_tip xsm_text text-light">Notifications</p>
        {taskNotifications.length + alertNotifications.length > 0 ?
          <span className="count px-3px w-auto h-auto py-2px">{taskNotifications.length + alertNotifications.length} </span>
          : null}
      </div>
      {notification && (
        <div ref={popupRef} className="ar-CurSession__Tab notfication">
          <Tab.Container defaultActiveKey="Tasks" ref={popupRef}>
            <div className="d-flex justify-content-between align-items-center mb-10 px-1">
              <p className="heading">Task Notifications</p>
            </div>
            <Nav variant="tabs" className="d-flex border-0 gx-0 justify-content-between px-1 mb-10">
              <Nav.Item>
                <Nav.Link eventKey="Tasks" className="md_text d-flex gap-1 align-items-center fs-10">Tasks
                  {taskNotifications.length > 0 ? <span className="ar_count position-static pt-0">{taskNotifications.length} </span> : null}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Alerts" className="md_text d-flex gap-1 align-items-center fs-10">Alerts
                  {alertNotifications.length > 0 ? <span className="ar_count position-static pt-0">{alertNotifications.length} </span> : null}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="All" className="md_text gap-1  d-flex align-items-center fs-10"> Other   <span className="ar_count position-static pt-0"> 1</span></Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="Tasks">
                <div>
                  <div className="d-flex flex-column gap-10 px-10 scroll hover-scrollbar pb-2 px-10 ar_task-notification">
                    {taskNotifications.length > 0 ?
                      taskNotifications.map((item, index) => {
                        return (
                          notificationType(item, index)
                        )
                      }) :
                      <div className="d-flex align-items-center justify-content-center flex-column gap-12 py-3 my-1">
                        <NoNotificationIcon classes={'fs-48'} />
                        <div className="text-center">
                          <p className='text fs-12 font-m'>No New Notifications!</p>
                          <p className='text fs-11 ar-ligh-color'>We’ll notify you once something comes up.</p>
                        </div>
                      </div>
                    }
                  </div>
                  {taskNotifications.length > 0 ?
                    <div className="px-10 d-flex align-items-center justify-content-end ar-footer gap-1">
                      <i className="bi bi-check-all fs-18"></i>
                      <p className="text fs-11 cursor-pointer" onClick={() => handleMarkAll()}>Mark All as read</p>
                    </div>
                    : null}
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="Alerts">
                <AlertNotofications
                  alertNotifications={alertNotifications}
                  OpenAlert={OpenAlert}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="All">
                <AllNotifications connection={connection} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      )}
    </>
  );
};

export default Notifications;